import React from "react";
import Modal from "react-modal";
import Button from "@mui/material/Button";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { GrCheckmark } from "react-icons/gr";
// import
// import "../css/tags.css";
import "../../css/tags.css";

// Modal.setAppElement("#root"); // Important for accessibility
Modal.setAppElement(document.getElementById("root"));
const ShareWithEmail = ({ visible, onClose, onCancel, options }) => {
  // console.log("options 5565", options);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: 0,
      border: "none",
      borderRadius: "15px",
      overflow: "hidden",
    },
  };

  return (
    <Modal
      isOpen={visible}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Share Modal"
    >
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flex: 1,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            width: "70%",
            alignItems: "center",

            borderRadius: 15,
          }}
        >
          {options.map((option, index) => (
            <Button
              key={index}
              onClick={() => option.onClick()}
              style={{
                width: "100%",
                height: 35,
                borderBottomColor: "grey",
                borderBottomWidth: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  fontSize: 15,
                  fontWeight: "400",
                  color: "#1c68ff",
                }}
              >
                {option.label}
              </p>
              {option.isSelected && (
                <GrCheckmark
                  style={{
                    position: "absolute",
                    right: 20,
                    tabSize: 30,
                    color: "rgb(0, 128, 0)",
                  }}
                  size={20}
                />
              )}
            </Button>
          ))}

          <Button
            onClick={onCancel}
            style={{
              width: "100%",
              height: 40,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: "#1c68ff",
              }}
            >
              Cancel
            </p>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ShareWithEmail;
